module.exports = [{
      plugin: require('../../../common/temp/node_modules/.pnpm/gatsby-remark-images@7.16.0_gatsby-plugin-sharp@5.16.0_gatsby@5.16.1_react-dom@18.3.1_react@1_nl6t2m57d7lir7hdfgzksr6m3i/node_modules/gatsby-remark-images/gatsby-browser.js'),
      options: {"plugins":[],"maxWidth":630,"linkImagesToOriginal":true,"showCaptions":false,"markdownCaptions":false,"backgroundColor":"white","quality":50,"withWebp":false,"withAvif":false,"loading":"lazy","decoding":"async","disableBgImageOnAlpha":false,"disableBgImage":false},
    },{
      plugin: require('../../../common/temp/node_modules/.pnpm/gatsby-plugin-baidu-analytics@2.2.0/node_modules/gatsby-plugin-baidu-analytics/gatsby-browser.js'),
      options: {"plugins":[],"siteId":"636a5367313a21e3afcffb107139ef3a","head":false},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../../../common/temp/node_modules/.pnpm/gatsby@5.16.1_react-dom@18.3.1_react@18.3.1__react@18.3.1_type-fest@4.41.0_typescript@5.9.3/node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
